<template>
  <div class="home_box" style="position: relative">
    <div class="top_box">
      <div class="item_box" style="margin-right: 20px">
        <div class="title">
          账户信息
          <span class="more" @click="$router.push({ name: 'user_center' })">查看更多</span>
        </div>
        <div class="info_item" style="margin-top: 20px">
          合作伙伴：<span class="val">{{ agent.agent_name }}</span>
        </div>
        <div class="info_item">
          管理账号：<span class="val">{{ agent.tel }}</span>
        </div>
        <div class="info_item" v-if="agent.tp">
          账户类型：<span class="val">{{ accountType[agent.code] }}</span>
        </div>
        <div class="info_item">
          注册时间：<span class="val">{{
            $moment(agent.agent_create_time)
          }}</span>
        </div>
        <div class="user_info_box">
          <div class="item">
            <img class="icon" src="../../assets/images/ic_principal.png" />
            <span>账户负责人：{{ agent.leader_tel }}</span>
          </div>
          <div class="item">
            <img class="icon" src="../../assets/images/ic_contacs.png" />
            <span>账户联络人：{{ agent.contacts_tel }}</span>
          </div>
        </div>
      </div>

      <div class="item_box">
        <div class="title">
          <span>
            营收信息
            <Tooltip content="统计均按A4单面计算，A3和双面自动2倍">
              <Icon type="ios-alert" />
            </Tooltip>

            <span class="data" style="margin-left: 5px">更新时间：{{ $moment(new Date()) }}</span>
          </span>
          <div class="r_date">
            <span v-if="!agent.tp" class="item" :class="{ active: dateIndex == 0 }" @click="selectDate(0)">今日</span>
            <span v-if="!agent.tp" class="line"></span>
            <span class="item" :class="{ active: dateIndex == 1 }" @click="selectDate(1)">昨日</span>
            <span class="line"></span>
            <span class="item" :class="{ active: dateIndex == 2 }" @click="selectDate(2)">更多</span>
          </div>
        </div>
        <div class="manage_content" v-if="!agent.tp">
          <div class="item" style="margin-right: 50px">
            <div class="tit">打印量</div>
            <div class="count">{{ profitData.PrintNum  }}</div>
          </div>
          <div class="item" style="margin-right: 50px">
            <div class="tit">扫描量</div>
            <div class="count">{{ profitData.ScanNum }}</div>
          </div>
          <div class="item">
            <div class="tit">订单量</div>
            <div class="count">{{ profitData.OrderNum }}</div>
          </div>
        </div>
        <div class="manage_content" v-else>
          <div class="item" style="margin-right: 50px">
            <div class="tit">打印量</div>
            <div class="count">-</div>
          </div>
          <div class="item" style="margin-right: 50px">
            <div class="tit">扫描量</div>
            <div class="count">-</div>
          </div>
          <div class="item">
            <div class="tit">订单量</div>
            <div class="count">-</div>
          </div>
        </div>
      </div>
    </div>
    <div class="item_box" style="margin-top: 20px; padding: 18px 16px 80px">
      <div class="title">
        <span>
          设备概览 <span class="data">更新时间：{{ $moment(new Date()) }}</span>
        </span>
      </div>
      <div class="manage_content">
        <div class="item">
          <div class="tit">云知印</div>
          <div class="count count2">
            <span>{{ data.aid }}</span>
            <span class="symbol">台</span>
          </div>
        </div>
        <!-- <div class="item" style="margin-left: 20px">
          <div class="tit">智能运维</div>
          <div class="count count2">
            <span>{{ data.meter }}</span>
            <span class="symbol">台</span>
          </div>
        </div> -->
        <div class="line"></div>
        <div class="item">
          <div class="tit">离线</div>
          <div class="count count2" style="cursor: pointer" @click="
            $router.push({ name: 'machine-list', params: { network: true } })
          ">
            <span style="color: #b12318">{{ data.offLine }}</span>
            <span class="symbol">台</span>
          </div>
        </div>
        <div class="item">
          <div class="tit">故障</div>
          <div class="count count2">
            <span style="color: #b12318">{{ data.error }}</span>
            <span class="symbol">台</span>
          </div>
        </div>
        <div class="line"></div>
        <div class="item">
          <div class="tit">即将到期</div>
          <div class="count count2">
            <span>{{ data.soonExpire }}</span>
            <span class="symbol">台</span>
          </div>
        </div>
        <div class="item">
          <div class="tit">已到期</div>
          <div class="count count2">
            <span style="color: #b12318">{{ data.expire }}</span>
            <span class="symbol">台</span>
          </div>
        </div>
      </div>
    </div>

    <div class="float-box" v-if="agent.tp">
      <img class="icon float-service" style="margin-top: 15px" src="../../assets/images/ic_float_service.png"
        @mouseover="service_show = true" @mouseleave="service_show = false" />
      <div class="float-service-box" v-if="service_show">
        <div class="title">电话客服</div>
        <a href="tel:4001886966">
          <div class="content">
            400 188 6966 <span class="hint">(周一至五 09:00-18:00)</span>
          </div>
        </a>
        <div class="title">邮件帮助</div>
        <a href="mailto:support@aidprint.com">
          <div class="content email">support@aidprint.com</div>
        </a>
        <div class="title">学校微信</div>
        <img class="wx_code" src="../../assets/images/ic_wx_gzh.png" />
      </div>
    </div>

    <Modal v-model="initTask" title="初始任务" :width="650" footer-hide :mask-closable="false" :closable="false">
      <div class="modal_title">
        为了您的账户信息和资金安全，请完成以下初始任务！
      </div>
      <div class="modal_content">
        <div>
          1、修改账户的初始登录密码；<br />2、为账户指定负责人<span style="font-size: 12px">（进行敏感信息操作时，会进行负责人权限验证）</span>；
        </div>
      </div>
      <div class="btn_confirm" style="margin: 40px auto 20px" @click="
        modalPwd.visible = true;
      initTask = false;
                ">
        开始
      </div>
    </Modal>
    <Modal :width="650" footer-hide title="修改密码" v-model="modalPwd.visible" :mask-closable="false" :closable="false">
      <div class="modal_title">
        请为账户设置新的密码，必须包含数字和字母，不低于6位！
      </div>

      <div style="margin-top: 40px">
        <Input v-model="modalPwd.password" style="width: 200px" size="large" type="password" placeholder="请输入新密码" />
      </div>
      <div style="margin: 20px 0 40px; display: flex; align-items: center">
        <Input v-model="modalPwd.rpassword" style="width: 200px" size="large" type="password" placeholder="请再次输入新密码" />
        <div class="btn_confirm" @click="savePWD">确认</div>
      </div>
    </Modal>
    <Modal v-model="modalVerify.visible" title="负责人设置" :width="650" :mask-closable="false" :closable="false" footer-hide>
      <div class="modal_verify">
        <div class="title">请为账户指定负责人！</div>
        <div class="des">
          负责人具有对账户敏感信息操作的权限，如收益分账设置
        </div>
        <div style="margin: 30px 0 50px">
          <div class="input_box">
            <Input v-model="modalVerify.principal_tel" class="input" size="large" placeholder="请填入负责人手机号" />
            <div class="getCode" @click="getCode">
              {{ verifiy.verifiyBtnText }}
            </div>
          </div>
          <div class="input_box" style="margin-top: 15px">
            <Input v-model="modalVerify.code" class="input" size="large" placeholder="请正确填入验证码" />
            <div class="confirm" @click="savePrincipal">确认</div>
          </div>
        </div>
      </div>
    </Modal>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>加载中...</div>
    </Spin>

    <Modal v-model="showNotice" title="通知" :width="900" footer-hide :mask-closable="false" :closable="false">
      <div style="color: #000;font-size: 18px;font-weight: bold;text-align: center;">分账暂时升级通知</div>
      <div style="font-size: 15px;line-height: 25px;margin: 18px 25px;text-indent:28px;color: black;">
        <div>各位合作伙伴，因近期国家对线上支付安全合规的管控，微信和支付宝等线上交易平台对分账功能在作升级调整，直接影响到了云知印平台的分账功能；预计4月初升级完成正式上线；</div>
        <div style="margin-top: 10px;"> 从2023年3月13日起（收益从2023年3月12日起）至升级完成上线期间，我们将暂停每日的分账，每日收益将自动进行累计，并生成待结算单，您可以登录云知印合作伙伴后台“财务管理”“分账记录”进行查询；</div>
        <div style="margin-top: 10px;">
          暂停分账期间累计的收益，我们将通过学校对公银行转学校对公银行的方式与您结算，同时您需要向云知印提供相同金额的发票（开票税额：6%，开票项目：服务费，发票类型：专票）；升级完成后，每日收益支持自动提现至个人银行账户或者学校对公银行账户，交易手续费1%，同时您也无需向云知印提供发票，与当前一致；
        </div>
        <div style="margin-top: 10px;">
          对此给您带来的不便，我们表示歉意！
        </div>
        <div style="text-align: right;">云知印</div>
        <div style="text-align: right;">2023年3月14日</div>
        <div style="text-align: center;margin-top: 20px;">
          <sapn style="font-size: 15px;background-color: #19be6b;border-radius: 5px;padding: 10px 40px;color: #fff;text-align: center;cursor: pointer;" @click="noticeOk">知道了</sapn>
        </div>
        <div style="margin-top: 10px;">
          <img style="height: 220px;" src="../../assets/images/company_wx.jpg">
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters, mapActions } from "vuex";
export default {
  name: "home",
  components: {},
  data() {
    return {
      service_show: false,
      loading: false,
      dateIndex: 0,
      data: {},
      profitData: {},
      initTask: false,
      modalPwd: {
        visible: false,
        password: "",
        rpassword: "",
      },
      modalVerify: {
        visible: false,
        isCode: false,
        principal_tel: "",
        code: "",
      },
      verifiy: {
        verifiyBtnText: "获取验证码",
        verifiyTime: 0,
        timer: null,
      },
      startTime: "",
      endTime: "",
      agent: {},
      showNotice: false,
      accountType:{
        "xiaoxian":"小闲",
        "hex":"十六进制"
      }
    };
  },
  mounted() {
    this.getData();
    //设置公告显示
    // let isShowNotice = Cookies.get('showNotice')
    // this.showNotice = !isShowNotice?true:false
  },
  computed: mapGetters({
    // agent: "agent",
    access: "access",
  }),
  methods: {
    ...mapActions([
      "handleLogin",
      "saveAgent",
      "FalseUpdPWD",
      "SendTelCode",
      "AgentSaveLeader",
      "GetMachineReport",
      "GetProfitReport",
      "getUserInfo",
      "SaveAdminUser",
    ]),
    getData() {
      this.loading = true;
      let now = new Date();
      this.startTime = this.$moment(now, "YYYY-MM-DD");
      this.endTime = this.$moment(now, "YYYY-MM-DD");

      this.GetMachineReport().then((res) => {
        this.data = res.data;
      });
      this.GetProfitReport({ start: this.startTime, end: this.endTime }).then(
        (res) => {
          this.profitData = res.data;
          this.loading = false;
        }
      );
      this.getUser();
    },
    getUser() {
      this.getUserInfo().then((res) => {
        this.agent = res;
        if (this.agent.tp) {
          this.selectDate(1);
        }
        if (this.agent.update_password && !this.agent.leader_tel) {
          this.initTask = true;
        } else {
          if (this.agent.update_password) {
            this.modalPwd.visible = true;
          }
          if (!this.agent.leader_tel) {
            this.modalVerify.visible = true;
          }
        }
      });
    },
    selectDate(index) {
      this.dateIndex = index;
      let now = new Date();
      switch (index) {
        case 0: //今日
          this.startTime = this.$moment(now, "YYYY-MM-DD");
          this.endTime = this.$moment(now, "YYYY-MM-DD");
          break;
        case 1: //昨日
          let yesterday = new Date(new Date() - 1000 * 60 * 60 * 24);
          this.startTime = this.$moment(yesterday, "YYYY-MM-DD");
          this.endTime = this.$moment(yesterday, "YYYY-MM-DD");
          break;
        case 2: //当月
          this.$router.push({ name: "amount" });
          // let last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          // this.startTime =this.$moment(last, "YYYY-MM") + "-01";
          // this.endTime = this.$moment(last, "YYYY-MM-DD")

          break;
      }
      this.GetProfitReport({ start: this.startTime, end: this.endTime }).then(
        (res) => {
          this.profitData = res.data;
        }
      );
    },
    getCode() {
      if (this.modalVerify.principal_tel) {
        if (this.verifiy.time) return false;

        this.verifiy.time = 60;
        this.verifiy.timer = setInterval(() => {
          if (this.verifiy.time) {
            this.verifiy.time--;
            this.verifiy.verifiyBtnText = `${this.verifiy.time}S`;
          } else {
            this.verifiy.time = 0;
            this.verifiy.verifiyBtnText = `获取验证码`;
            clearInterval(this.verifiy.timer);
          }
        }, 1000);
        this.SendTelCode({ tel: this.modalVerify.principal_tel, type: 0 }).then(
          (res) => {
            this.$Message[res.status ? "success" : "error"](res.msg);
            if (res.status) {
              this.modalVerify.isCode = true;
            }
          }
        );
      } else {
        this.$Message.error("请填入新负责人手机号！");
      }
    },
    savePrincipal() {
      if (this.modalVerify.code) {
        this.AgentSaveLeader({
          agent_id: this.agent.id,
          leader_tel: this.modalVerify.principal_tel,
          code: this.modalVerify.code,
        }).then((res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (res.status) {
            this.modalVerify.visible = false;
            this.getUser();
          }
        });
      } else {
        this.$Message.error("请填入验证码");
      }
    },
    savePWD() {
      if (!this.modalPwd.password) {
        this.$Message.error("请输入新密码");
        return false;
      }
      if (this.modalPwd.password === "123456") {
        this.$Message.error("新密码不可为初始密码");
        return false;
      }
      if (this.modalPwd.password !== this.modalPwd.rpassword) {
        this.$Message.error("两次密码不一致");
        return false;
      }
      let pwdRegex = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}");
      if (!pwdRegex.test(this.modalPwd.password)) {
        this.$Message.error("密码必须包含数字和字母，长度不低于6位");
        return false;
      }
      if (this.modalPwd.password.length < 6) {
        this.$Message.error("密码长度不低于6位");
        return false;
      }
      if (!this.agent.role_user_id) {
        this.saveAgent({
          user: { id: this.agent.user_id, password: this.modalPwd.password },
          user_agent: { id: this.agent.id, name: this.agent.name },
        }).then((res) => {
          if (res.status) {
            this.modalPwd.visible = false;
            this.$Message.success("密码修改成功");
            this.FalseUpdPWD();
            if (!this.agent.leader_tel) {
              this.modalVerify.visible = true;
            }
          }
        });
      } else {
        this.SaveAdminUser({
          id: this.agent.role_user_id,
          password: this.modalPwd.password,
        }).then((res) => {
          if (res.status) {
            this.modalPwd.visible = false;
            this.$Message.success("密码修改成功");
            this.FalseUpdPWD();
            if (!this.agent.leader_tel) {
              this.modalVerify.visible = true;
            }
          }
        });
      }
    },
    noticeOk(){
      this.showNotice=false
      Cookies.set('showNotice',true, { expires: 50 })//50天有效期
    },
    testClick(type){
      this.$router.push({name:type==1?'dispense-merchant':'payment-detail'})
    }
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>
